import React, { useState } from "react";
import { showNotification, getStudentId } from "../../utils";
import Api from "../../api";
import "./code_input.css";

const CodeInput = () => {
  const [code, setCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCodeChange = (e) => {
    const value = e.target.value.toUpperCase();
    // Only allow Latin alphabet letters including Ñ, max 3 characters
    const filtered = value.replace(/[^A-ZÑ]/g, "").slice(0, 3);
    setCode(filtered);
  };

  const handleSubmit = async () => {
    if (code.length !== 3) {
      showNotification("Aviso", "El código debe tener exactamente 3 letras", "warning");
      return;
    }

    const studentId = getStudentId();
    if (!studentId) {
      showNotification("Error", "No se pudo obtener el ID del estudiante", "danger");
      return;
    }

    const formattedCode = `${code.toUpperCase()}-${studentId}`;

    setIsSubmitting(true);
    try {
      await Api.Code.SubmitCode(studentId, { code: formattedCode });
      showNotification("¡Éxito!", "Código enviado correctamente", "success");
      setCode("");
    } catch (error) {
      showNotification("Error", error.message || "Error al enviar el código", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <div className="code-input-container">
      <h2 className="code-input-title">Ingresa aquí tu código</h2>
      <p className="code-input-subtitle">
        Recuerda que esto es para habilitar el acceso a tu clase sincrónica
      </p>
      <input
        className="code-input-field"
        type="text"
        placeholder="ABC"
        value={code}
        onChange={handleCodeChange}
        onKeyDown={handleKeyDown}
        disabled={isSubmitting}
        maxLength={3}
      />
      <div className="code-input-button-container">
        <button
          className="code-input-button"
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Enviando..." : "Enviar"}
        </button>
      </div>
    </div>
  );
};

export default CodeInput;
